import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UploadComponent } from '../upload/upload.component';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
})
export class AttachmentComponent implements OnInit, OnDestroy {
  uploadFile = (id: string, file: File): Observable<any> => null;

  Title: string;
  SubTitle: string;
  Id: string;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  @ViewChild(UploadComponent) uploadComponent: UploadComponent;

  constructor(
    private dialogRef: MatDialogRef<AttachmentComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.Title = data.Title;
    this.SubTitle = data.SubTitle;
    this.Id = data.Id;
    this.uploadFile = data.UploadFile;
  }

  ngOnInit(): void {}

  get hasFiles(): boolean {
    return !_.isNil(this.uploadComponent) && this.uploadComponent.hasFiles;
  }

  onSubmit(): void {
    if (this.uploadComponent.hasFiles) {
      this.onConfirm();
    }
  }

  onConfirm() {
    this.uploadFile(this.Id, this.uploadComponent.Files[0])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (_) => {
          this.close(true);
        },
        (_) => {
          this.close(false);
        }
      );
  }

  close(isSuccess: boolean) {
    this.dialogRef.close(isSuccess);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
